<div class="row footer">
    <div class='col-xs-offset-1 col-xs-10' style="margin-bottom:2em;">
      <div class="flex-container">
        <div class="flex-item">
          <img src="assets/images/icon_footer1.gif" />
          <p>100% kostenfrei & unverbindlich</p>
        </div>
        <div class="flex-item">
          <img src="assets/images/icon_footer3.gif" /> 
          <p>Beratung durch erfahrene Verrentungsexperten​</p>
        </div>
        <div class="flex-item ">
          <img class="footer-img" src="assets/images/icon_footer2.gif" /> 
          <p>Zertifizierte Leistungen</p>
        </div>
        <div class="flex-item footer-img">
        <img src="assets/images/degiv_dekra_clickable_logo.png" height="65" />
        <img src="assets/images/TR-Testmark_9108653678_DE_CMYK_without-QR-Code.png" height="65" />
      </div>
      </div>
    </div>
    
    <mat-progress-bar mode="determinate" value="{{progress}}" color="#f00"></mat-progress-bar>
  </div>